import _ from 'lodash';

export const FOLDER_DELIMITER = '/';

export function getFileName(path: string): string {
  const lastIndex = _.lastIndexOf(path, FOLDER_DELIMITER);

  if (lastIndex < 0) {
    return path;
  }

  return path.substr(lastIndex + 1);
}

export function composeFilePath(path: string | undefined, fileName: string) {
  if (!_.isString(path)) {
    return FOLDER_DELIMITER + fileName;
  }

  if (_.endsWith(path, FOLDER_DELIMITER)) {
    return path + fileName;
  }

  return path + FOLDER_DELIMITER + fileName;
}

export function removeLastDelimiter(folderPath?: string): string {
  return _.trimEnd(folderPath, FOLDER_DELIMITER);
}

export function getURLSafeFilePath(path: string): string {
  const pathParts = path.split(FOLDER_DELIMITER);
  const encodedPathParts = pathParts.map((part) => {
    return containsEncodedComponents(part) ? part : encodeURIComponent(part);
  });
  return encodedPathParts.join(FOLDER_DELIMITER);
}

function containsEncodedComponents(uri: string) {
  try {
    return decodeURI(uri) !== decodeURIComponent(uri);
  } catch (e) {
    // URI is malformed === it is not encoded (% not followed by 2 hex digits)
    return false;
  }
}
